import globalevents_controller from '../globalevents/globalevents_controller'
import LazyLoad from 'vanilla-lazyload'
import { load_visible_images_then_rest_controller } from './load_visible_images_then_rest'
import projects_overlays from '../projects_overlays/projects_overlays'
import debounce from 'lodash/debounce'

// just an empty function so theres no error in old plugins

window.lazySizes = {
	loader: {
		unveil: function (t) {},
	},
}

var bindScrollForSplitscreenWebsite = function () {
	// Track previously-attached listeners so each newpageshown can detach
	// them before reattaching. Without this every navigation stacked
	// another listener on the same element, multiplying scroll-emit
	// frequency by 2× / 3× / etc on long sessions.
	let prevFooter = null
	let prevFooterListener = null
	let prevGrid = null
	let prevGridListener = null

	window.laytheme.on('newpageshown', function (layoutObj, type, obj, isProjectOverlayObj) {
		// Splitscreen is a body-level layout feature; the project overlay
		// scope has its own scroll handling. Skip overlay-scope events so
		// we don't bind listeners on stale `body>.lay-content` queries
		// from inside an overlay-scope handler.
		if (isProjectOverlayObj && isProjectOverlayObj.isProjectOverlay === true) return

		// for splitscreen website, jQuery(document).on('scroll' doesn't trigger! so i bind scroll to footer and #grid here
		// we need to bind scroll here, so carousel can load if carousel uses lazyloading
		// other scroll based interactions are just intersectionobserver

		if (prevFooter && prevFooterListener) {
			prevFooter.removeEventListener('scroll', prevFooterListener)
		}
		if (prevGrid && prevGridListener) {
			prevGrid.removeEventListener('scroll', prevGridListener)
		}

		const footer = document.querySelector('body>.lay-content #footer-region')
		if (footer) {
			const listener = () => {
				window.eventsChannel.emit('scroll', 0, footer.scrollHeight)
			}
			footer.addEventListener('scroll', listener)
			prevFooter = footer
			prevFooterListener = listener
		} else {
			prevFooter = null
			prevFooterListener = null
		}
		const grid = document.querySelector('body>.lay-content #grid')
		if (grid) {
			const listener = () => {
				window.eventsChannel.emit('scroll', 0, grid.scrollHeight)
			}
			grid.addEventListener('scroll', listener)
			prevGrid = grid
			prevGridListener = listener
		} else {
			prevGrid = null
			prevGridListener = null
		}
	})
}

var addHttpsMaybe = function (url) {
	if (url === null || url === undefined) {
		return null
	}
	if (url.startsWith('mailto:')) {
		return url
	}
	if (url.startsWith('tel:')) {
		return url
	}
	if (url.toLowerCase().startsWith('sms:')) {
		return url
	}
	if (url.startsWith('#')) {
		return url
	}
	if (url.substring(0, 4) != 'http') {
		return 'https://' + url
	}
	return url
}

var utility_controller = {
	i: function () {
		setScrollBarWidthCssVar()
		jQuery(window).trigger('window_width_changed', setScrollBarWidthCssVar)
		initResizeOnlyWindowWidthEvent()
		bindScroll()
		bindScrollForSplitscreenWebsite()
		bindResize()
		initScreenSize()
		triggerSizeChanged()
		setOrientation()
		initIsTouchDevice()
		setSupportsPlaysinlineOnTouchdevices()
		// configureLazySizes()
		loadImagesInstantly()
		bindSizeBackgrounds()
		onGlobalEvents()
		bindOnFullpageRenderResizeBackgrounds()
	},
	isProjectsOverlayEnabled: function () {
		if (layData.projects_overlays == '') {
			return false
		}

		var ua2 = (navigator.userAgent || navigator.vendor || window.opera).toLowerCase()
		var isInstagram = ua2.indexOf('instagram') > -1 ? true : false

		if (layData.disable_projectsoverlays_on_ig == 'on' && isInstagram) {
			return false
		}
		if (layData.disable_projectsoverlays_on_touchdevices == 'on' && Utility.isTouchDevice) {
			return false
		}
		if (layData.projects_overlays == 'on') {
			return true
		}

		return true
	},
	addHttpsMaybe: function (url) {
		return addHttpsMaybe(url)
	},
	map: function (value, istart, istop, ostart, ostop) {
		return map(value, istart, istop, ostart, ostop)
	},
	filterURL: function (url) {
		return filterURL(url)
	},
	isInternUrl: function (url) {
		return isInternUrl(url)
	},
	stringStartsWith: function (string, prefix) {
		return stringStartsWith(string, prefix)
	},
	fixBody: function (applyFixBodyStyle, reason) {
		if (typeof applyFixBodyStyle == 'undefined') {
			applyFixBodyStyle = false
		}
		fixBody(applyFixBodyStyle, reason)
	},
	unfixBody: function () {
		unfixBody()
	},
	fixBodyAlt: function () {
		fixBodyAlt()
	},
	stringifyCatIds: function (catids) {
		return stringifyCatIds(catids)
	},
	parseIdsString: function (catids) {
		return parseIdsString(catids)
	},
	fadeInImageOnLoadViaParent: function ($target) {
		fadeInImageOnLoadViaParent($target)
	},
	setSrcAndSrcSetViaParent: function ($target) {
		setSrcAndSrcSetViaParent($target)
	},
	setBodyClasses: function (obj) {
		setBodyClasses(obj)
	},
	setImageSizesAttribute: function ($target) {
		setImageSizesAttribute($target)
	},
	getImageSrcAndSrcSet: function (el) {
		return getImageSrcAndSrcSet(el)
	},
	getTargetContainers: function (typeOfContentThatIsReady) {
		return getTargetContainers(typeOfContentThatIsReady)
	},
	roundUpSizes: function (w) {
		return roundUpSizes(w)
	},
	getTargetContainersExceptPageOverlay: function (typeOfContentThatIsReady) {
		return getTargetContainersExceptPageOverlay(typeOfContentThatIsReady)
	},
	isBodyFixed: function () {
		return isFixed
	},
}

var detectBrowserAndBrowserVersion = function () {
	mbrowser = function () {
		this.spec_string = navigator.userAgent
		this.name = this.get_name()
		this.version = this.get_version()
	}

	mbrowser.prototype.get_name = function () {
		var spec_string = this.spec_string

		var matches = spec_string.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []

		// Work with the matches.
		matches = matches[2] ? [matches[1], matches[2]] : [navigator.appName, navigator.appVersion, '-?']

		// Trident.
		if (/trident/i.test(matches[1])) {
			var temp = /\brv[ :]+(\d+)/g.exec(spec_string) || []
			return 'IE'
		}

		// Chrome.
		if (matches[1] === 'Chrome') {
			var temp = spec_string.match(/\bOPR|Edge\/(\d+)/)
			if (temp != null) {
				return 'Opera'
			}
		}

		if ((temp = spec_string.match(/version\/(\d+)/i)) != null) {
			matches.splice(1, 1, temp[1])
		}

		var name = matches[0]

		return name
	}

	mbrowser.prototype.get_version = function () {
		var spec_string = this.spec_string

		var matches = spec_string.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []

		// Work with the matches.
		matches = matches[2] ? [matches[1], matches[2]] : [navigator.appName, navigator.appVersion, '-?']

		// Trident.
		if (/trident/i.test(matches[1])) {
			var temp = /\brv[ :]+(\d+)/g.exec(spec_string) || []
			var version = temp[1] || ''
			return version
		}

		// Chrome.
		if (matches[1] === 'Chrome') {
			var temp = spec_string.match(/\bOPR|Edge\/(\d+)/)
			var version = temp[1]
			if (temp != null) {
				return version
			}
		}

		if ((temp = spec_string.match(/version\/(\d+)/i)) != null) {
			matches.splice(1, 1, temp[1])
		}

		var version = matches[1]

		return version
	}
	// m=module.
	var browser = new mbrowser()

	return { name: browser.name, version: browser.version }
}

var browserAndVersion = detectBrowserAndBrowserVersion()

var Utility = {
	orientation: window.innerWidth > window.innerHeight ? 'landscape' : 'portrait',
	previousOrientation: window.innerWidth > window.innerHeight ? 'landscape' : 'portrait',
	isPhoneSize: null,
	isDesktopSize: null,
	isTabletSize: null,
	isNotPhoneSize: null,
	screenSize: null,
	phoneMenuBreakpoint: parseInt(layData.phone_menu_breakpoint, 10),
	breakpoint: parseInt(layData.breakpoint, 10),
	tabletBreakpoint: parseInt(layData.tabletbreakpoint, 10),
	phoneBreakpoint: parseInt(layData.breakpoint, 10),
	isTouchDevice: false,
	supportsPlaysInline: false,
	showOriginalImages: layData.misc_options_showoriginalimages == 'on' ? true : false,
	imageSizes: ['265', '512', '768', '1024', '1280', '1920', '2560', '3200', '3840', '4096'],
	browserName: browserAndVersion.name,
	browserVersion: browserAndVersion.version,
	setImageSizesAttribute: function ($target) {
		setImageSizesAttribute($target)
	},
}

window.layUpdateImageSizes = function () {
	setImageSizesAttribute()
	if (window.lazyLoadInstance != undefined) {
		window.lazyLoadInstance.update()
	}
}

var hasLoadedRealImage = function (img) {
	var activeSrc = img.currentSrc || img.src || img.getAttribute('src') || ''
	return img.complete && img.naturalWidth > 0 && activeSrc.indexOf('data:image') !== 0
}

var markLazyImageLoaded = function (img) {
	img.classList.remove('lazyloading')
	img.classList.remove('loaded-error')
	img.classList.add('lazyload')
	img.classList.add('lazyloaded')
	img.classList.add('loaded')
}

var initOrUpdateLazyload = function () {
	setTimeout(function () {
		if (window.lazyLoadInstance == undefined) {
			window.lazyLoadInstance = new LazyLoad({
				// Your custom settings go here
				elements_selector: '.lazyload',
				class_loaded: 'lazyloaded',
				class_error: 'loaded-error',
				class_loading: 'lazyloading',
				// use_native: true,
				callback_enter: function (element) {},
				callback_reveal: function (element) {
					// Fix for cached images: if image is already loaded when lazyloading starts,
					// vanilla-lazyload might miss the load event and leave it stuck in "lazyloading" state
					if (element.tagName === 'IMG') {
						var checkIfAlreadyLoaded = function () {
							if (hasLoadedRealImage(element)) {
								markLazyImageLoaded(element)
							}
						}
						// Check immediately and after a short delay
						checkIfAlreadyLoaded()
						setTimeout(checkIfAlreadyLoaded, 50)
						setTimeout(checkIfAlreadyLoaded, 200)
					}
				},
				callback_loaded: function (element) {
					if (element.tagName === 'IMG') {
						markLazyImageLoaded(element)
					}
				},
			})
		} else {
			window.lazyLoadInstance.update()
		}
	}, 0)
}

var scrollsliderLazyloadFallbackTimeout = undefined
var $pendingScrollsliderLazyloadScope = undefined

var hasScrollsliderLazyloadMarkup = function ($scope) {
	if (!$scope || $scope.length == 0) {
		return false
	}
	return $scope.hasClass('simpler-markup-for-scrollslider') || $scope.find('.simpler-markup-for-scrollslider').length > 0
}

var isScrollsliderWaitingForReveal = function ($scope) {
	if (!hasScrollsliderLazyloadMarkup($scope)) {
		return false
	}
	var $layContent = $scope.hasClass('lay-content') ? $scope : $scope.closest('.lay-content')
	return !$layContent.hasClass('scrollslider-show')
}

var initOrUpdateLazyloadForScope = function ($scope) {
	setImageSizesAttribute($scope)
	loadImagesInImagehoverRegion()
	initOrUpdateLazyload()
}

var clearScrollsliderLazyloadFallback = function () {
	if (scrollsliderLazyloadFallbackTimeout != undefined) {
		clearTimeout(scrollsliderLazyloadFallbackTimeout)
		scrollsliderLazyloadFallbackTimeout = undefined
	}
}

var runScrollsliderLazyload = function ($scope) {
	clearScrollsliderLazyloadFallback()
	$pendingScrollsliderLazyloadScope = undefined
	initOrUpdateLazyloadForScope($scope)
}

var deferLazyloadUntilScrollsliderReady = function ($scope) {
	$pendingScrollsliderLazyloadScope = $scope
	clearScrollsliderLazyloadFallback()
	// Scrollslider emits `scrollslider-ready` after it has positioned the grid
	// and added `.scrollslider-show`. The fallback is only for older plugin
	// builds or unexpected init paths where that event never arrives.
	scrollsliderLazyloadFallbackTimeout = setTimeout(function () {
		initOrUpdateLazyloadForScope($scope)
		scrollsliderLazyloadFallbackTimeout = undefined
		$pendingScrollsliderLazyloadScope = undefined
	}, 700)
}

var onGlobalEvents = function () {
	window.laytheme.on('newpageshown', function (layoutObj, type, obj, isProjectOverlayObj) {
		// Scope the per-page work to the event's scope so a double-fire
		// (overlay + lazy-loaded underlay in the upcoming direct-load flow)
		// processes each scope's images once, not the union twice.
		// fadeInImageOnLoadViaParent uses addEventListener under the hood —
		// without scoping, a second fire on the union would attach duplicate
		// load listeners to the other scope's images.
		const isProjectOverlay = isProjectOverlayObj && isProjectOverlayObj.isProjectOverlay === true
		const $scope = isProjectOverlay ? jQuery('#lay-project-overlay > .lay-content') : jQuery('body > .lay-content')
		// first set sizes attribute
		setImageSizesAttribute($scope)
		loadImagesInImagehoverRegion()
		// then start lazyloading images! (LazyLoad instance is global by design —
		// it auto-discovers any new .lazyload elements site-wide on .update())
		if (isScrollsliderWaitingForReveal($scope)) {
			// Scrollslider server-renders simplified markup hidden at opacity 0,
			// then positions/reveals it in its plugin JS. Starting LazyLoad before
			// that reveal lets IntersectionObserver see too much at once on large
			// Scrollslider pages, so wait for the plugin's ready event.
			deferLazyloadUntilScrollsliderReady($scope)
		} else {
			initOrUpdateLazyload()
		}
		fadeInImageOnLoadViaParent($scope)
		// Instagram's own embed script dedupes by data-instgrm-payload-id, so a
		// double process() call is safe.
		processInstagramEmbeds()
	})

	window.laytheme.on('content_ready', function (typeOfContentThatIsReady, $target) {
		var $scope = $target && $target.length > 0 ? $target.closest('.lay-content') : jQuery('body > .lay-content')
		if (isScrollsliderWaitingForReveal($scope)) {
			deferLazyloadUntilScrollsliderReady($scope)
		}
	})

	window.laytheme.on('scrollslider-ready', function ($laycontent) {
		var $scope = $laycontent && $laycontent.length > 0 ? $laycontent : $pendingScrollsliderLazyloadScope
		if (hasScrollsliderLazyloadMarkup($scope)) {
			runScrollsliderLazyload($scope)
		}
	})

	window.laytheme.on('overlayshown', function () {
		setImageSizesAttribute()
		loadImagesInImagehoverRegion()
		// then start lazyloading images!
		initOrUpdateLazyload()
	})

	window.laytheme.on('woocommerce_initialized', function () {
		initOrUpdateLazyload()
	})

	window.laytheme.on('searchresultshown', function () {
		var $target = jQuery('#search-region')
		setImageSizesAttribute($target)
		setSrcAndSrcSetViaParent($target)
		fadeInImageOnLoadViaParent($target)
		initOrUpdateLazyload()
	})

	window.laytheme.on('newsLoadMore', function ($newsElement) {
		setImageSizesAttribute($newsElement)
		initOrUpdateLazyload()
	})

	// when updating cart item quantities
	jQuery(document.body).on('updated_cart_totals', function () {
		initOrUpdateLazyload()
	})
}

var getTargetContainersExceptPageOverlay = function (typeOfContentThatIsReady) {
	var $target = undefined
	switch (typeOfContentThatIsReady) {
		case 'desktop': {
			var nodes = []
			nodes = nodes.concat(Array.from(document.querySelectorAll('body>.lay-content #grid, body>.lay-content .cover-region-desktop, body>.lay-content #footer, #lay-project-overlay>.lay-content #grid, #lay-project-overlay>.lay-content .cover-region-desktop, #lay-project-overlay>.lay-content #footer')))
			nodes = nodes.concat(Array.from(document.querySelectorAll('body>.lay-content #lay-woocommerce')))

			// for woocommerce archive pages:
			if (jQuery('body').hasClass('archive') && jQuery('body').hasClass('woocommerce')) {
				nodes = nodes.concat(Array.from(document.querySelectorAll('#lay-woocommerce #grid')))
			}
			nodes = nodes.concat(Array.from(document.querySelectorAll('#search-region')))

			$target = jQuery(nodes)
			break
		}
		case 'phone': {
			var nodes = []
			jQuery('body>.lay-content').each(function () {
				var footerHasPhoneCPL = jQuery(this).find('#footer-custom-phone-grid').length != 0
				var hasCPL = jQuery(this).find('#custom-phone-grid').length != 0
				if (footerHasPhoneCPL && hasCPL) {
					nodes = nodes.concat(Array.from(this.querySelectorAll('#custom-phone-grid, .cover-region-phone, #footer-custom-phone-grid')))
				} else if (!footerHasPhoneCPL && hasCPL) {
					nodes = nodes.concat(Array.from(this.querySelectorAll('#custom-phone-grid, .cover-region-phone, #footer')))
				} else if (footerHasPhoneCPL && !hasCPL) {
					nodes = nodes.concat(Array.from(this.querySelectorAll('#grid, .cover-region-desktop, #footer-custom-phone-grid')))
				} else if (!footerHasPhoneCPL && !hasCPL) {
					nodes = nodes.concat(Array.from(this.querySelectorAll('#grid, .cover-region-desktop, #footer')))
				}
			})

			jQuery('#lay-project-overlay>.lay-content').each(function () {
				var footerHasPhoneCPL = jQuery(this).find('#footer-custom-phone-grid').length != 0
				var hasCPL = jQuery(this).find('#custom-phone-grid').length != 0
				if (footerHasPhoneCPL && hasCPL) {
					nodes = nodes.concat(Array.from(this.querySelectorAll('#custom-phone-grid, .cover-region-phone, #footer-custom-phone-grid')))
				} else if (!footerHasPhoneCPL && hasCPL) {
					nodes = nodes.concat(Array.from(this.querySelectorAll('#custom-phone-grid, .cover-region-phone, #footer')))
				} else if (footerHasPhoneCPL && !hasCPL) {
					nodes = nodes.concat(Array.from(this.querySelectorAll('#grid, .cover-region-desktop, #footer-custom-phone-grid')))
				} else if (!footerHasPhoneCPL && !hasCPL) {
					nodes = nodes.concat(Array.from(this.querySelectorAll('#grid, .cover-region-desktop, #footer')))
				}
			})

			nodes = nodes.concat(Array.from(document.querySelectorAll('body>.lay-content #lay-woocommerce')))

			nodes = nodes.concat(Array.from(document.querySelectorAll('#search-region')))
			// for woocommerce archive pages:
			if (jQuery('body').hasClass('archive') && jQuery('body').hasClass('woocommerce')) {
				nodes = nodes.concat(Array.from(document.querySelectorAll('#lay-woocommerce #grid')))
			}

			$target = jQuery(nodes)
			break
		}
	}
	return $target
}

var getTargetContainers = function (typeOfContentThatIsReady) {
	var $target = undefined
	switch (typeOfContentThatIsReady) {
		case 'desktop': {
			var nodes = []
			jQuery('.lay-content').each(function () {
				nodes = nodes.concat(Array.from(this.querySelectorAll('#grid, .cover-region-desktop, #footer')))
			})
			nodes = nodes.concat(Array.from(document.querySelectorAll('#lay-woocommerce')))
			$target = jQuery(nodes)
			break
		}
		case 'phone': {
			var nodes = []
			// need to iterate over .lay-content because when using overlays we can have multiple .lay-content containers
			jQuery('.lay-content').each(function () {
				var footerHasPhoneCPL = jQuery(this).find('#footer-custom-phone-grid').length != 0
				var hasCPL = jQuery(this).find('#custom-phone-grid').length != 0
				if (footerHasPhoneCPL && hasCPL) {
					nodes = nodes.concat(Array.from(this.querySelectorAll('#custom-phone-grid, .cover-region-phone, #footer-custom-phone-grid')))
				} else if (!footerHasPhoneCPL && hasCPL) {
					nodes = nodes.concat(Array.from(this.querySelectorAll('#custom-phone-grid, .cover-region-phone, #footer')))
				} else if (footerHasPhoneCPL && !hasCPL) {
					nodes = nodes.concat(Array.from(this.querySelectorAll('#grid, .cover-region-desktop, #footer-custom-phone-grid')))
				} else if (!footerHasPhoneCPL && !hasCPL) {
					nodes = nodes.concat(Array.from(this.querySelectorAll('#grid, .cover-region-desktop, #footer')))
				}
			})
			nodes = nodes.concat(Array.from(document.querySelectorAll('#lay-woocommerce')))
			$target = jQuery(nodes)
			break
		}
	}
	nodes = nodes.concat(Array.from(document.querySelectorAll('#search-region')))
	return $target
}

var setScrollBarWidthCssVar = function () {
	const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
	document.body.style.setProperty('--scrollbarWidth', scrollbarWidth + 'px')
}

var getImageSrcAndSrcSet = function (el) {
	var srcset = ''
	var smallest_src = ''
	var full_src = el.sizes.full
	full_src = filterURL(full_src)

	// SVGs have no raster sub-sizes — a srcset would only point at the same
	// file under bogus width descriptors. Output the original SVG, no srcset.
	if (typeof full_src === 'string' && full_src.substr(full_src.length - 4).toLowerCase() === '.svg') {
		return { src: full_src, srcset: '' }
	}

	var sizesToBeFilled = ['_265', '_512', '_768', '_1024', '_1280', '_1920', '_2560', '_3200', '_3840', '_4096']
	var sizes = el.sizes

	for (var key in sizes) {
		if (key != 'full') {
			var src = sizes[key]
			src = filterURL(src)
			// $src = LTUtility::getFullURL($src);
			srcset = src + ' ' + key.substring(1) + 'w, ' + srcset
			var ix = sizesToBeFilled.indexOf(key)
			if (ix !== -1) {
				sizesToBeFilled.splice(ix, 1)
			}
		}
	}

	// fill rest of sizes with full image
	for (var i = 0; i < sizesToBeFilled.length; i++) {
		srcset += full_src + ' ' + sizesToBeFilled[i].substring(1) + 'w, '
	}

	srcset = srcset.slice(0, -2)

	var smallest = sizes.hasOwnProperty('_265') != -1 ? sizes['_265'] : false
	if (smallest == '' || smallest == false) {
		smallest_src = full_src
	} else {
		smallest_src = smallest
	}

	smallest_src = filterURL(smallest_src)

	return { src: smallest_src, srcset: srcset }
}

var bindOnFullpageRenderResizeBackgrounds = function () {
	jQuery(window).on('fpAfterRender', function () {
		setTimeout(function () {
			// need to reset sizes attributes of background images because height of row has changed after init, if row was not 100vh before
			setBackgroundSizesAttribute()
			// In case one or more image elements with the attribute data-sizes="auto" have changed in size lazySizes.autoSizer.updateElems can be called (For example to implement element queries):
			// lazySizes.autoSizer.checkElems()
		}, 0)
	})
}

var fadeInImageOnLoadViaParent = function ($target) {
	if (typeof $target == 'undefined') {
		$target = jQuery('.lay-content')
	}
	// all images that do not use lazysizes
	$target.find('img.setsizes, img.lay-gif, img.lay-image-original').each(function () {
		var img = this
		if (img.complete) {
			img.classList.add('loaded')
		} else {
			img.addEventListener('load', function () {
				img.classList.add('loaded')
			})
		}
	})
}

var bindScroll = function () {
	var lastScrollPos = 0
	jQuery(document).on('scroll', function () {
		window.eventsChannel.emit('scroll', window.scrollY, document.body.scrollHeight, {
			source: 'normal-page',
			target: document,
		})
		if (window.scrollY > lastScrollPos) {
			document.body.classList.add('lay-scrolled-down')
		} else {
			document.body.classList.remove('lay-scrolled-down')
		}
		if (window.scrollY >= window.innerHeight) {
			document.body.classList.add('lay-scrolled-down-one-browserheight')
		} else {
			document.body.classList.remove('lay-scrolled-down-one-browserheight')
		}
		lastScrollPos = window.scrollY
	})
	// Initial state in case page is loaded already scrolled
	if (window.scrollY >= window.innerHeight) {
		document.body.classList.add('lay-scrolled-down-one-browserheight')
	} else {
		document.body.classList.remove('lay-scrolled-down-one-browserheight')
	}

	// project overlay
	var lastScrollPosProjectOverlay = 0
	const scroller = document.querySelector('#lay-project-overlay')
	jQuery('#lay-project-overlay').on('scroll', function () {
		const y = scroller.scrollTop

		window.eventsChannel.emit('scroll', y, scroller.scrollHeight, {
			source: 'project-overlay',
			target: scroller,
		})
		if (scroller.scrollTop > lastScrollPosProjectOverlay) {
			document.body.classList.add('lay-scrolled-down')
		} else {
			document.body.classList.remove('lay-scrolled-down')
		}
		if (scroller.scrollTop >= window.innerHeight) {
			document.body.classList.add('lay-scrolled-down-one-browserheight')
		} else {
			document.body.classList.remove('lay-scrolled-down-one-browserheight')
		}
		lastScrollPosProjectOverlay = scroller.scrollTop
	})

	// page overlays

	// using newpageshown and then bind because lay-overlay is added dynamically through ajax :)
	var bindPageOverlayScroll = function () {
		jQuery('.lay-overlay>.lay-content').off('scroll', doPageOverlayScroll)
		jQuery('.lay-overlay>.lay-content').on('scroll', doPageOverlayScroll)
	}
	window.laytheme.on('newpageshown', bindPageOverlayScroll)
	window.laytheme.on('page_overlay_markup_ready', bindPageOverlayScroll)
}

var doPageOverlayScroll = function () {
	const y = this.scrollTop
	const scrollHeight = this.scrollHeight
	window.eventsChannel.emit('scroll', y, scrollHeight, {
		source: 'page-overlay',
		target: this,
	})
}

var stringifyCatIds = function (catids) {
	if (catids == '' || typeof catids == 'undefined' || catids == null || catids == '[undefined]') {
		return '[]'
	}
	if (typeof catids == 'string') {
		return catids
	}
	for (var i = 0; i < catids.length; i++) {
		catids[i] = parseInt(catids[i], 10)
	}

	return JSON.stringify(catids)
}

var parseIdsString = function (catids) {
	if (catids == '' || typeof catids == 'undefined' || catids == null || catids == '[undefined]') {
		return []
	}
	if (Array.isArray(catids)) {
		return catids
	}
	var catids = JSON.parse(catids)
	for (var i = 0; i < catids.length; i++) {
		catids[i] = parseInt(catids[i], 10)
	}

	return catids
}

var stringStartsWith = function (string, prefix) {
	return string.slice(0, prefix.length).toLowerCase() == prefix.toLowerCase()
}

// https://gist.github.com/peteboere/1517285

/**
 * jQuery alterClass plugin
 *
 * Remove element classes with wildcard matching. Optionally add classes:
 *   $( '#foo' ).alterClass( 'foo-* bar-*', 'foobar' )
 *
 * Copyright (c) 2011 Pete Boere (the-echoplex.net)
 * Free under terms of the MIT license: http://www.opensource.org/licenses/mit-license.php
 *
 */

var alterClass = function ($el, removals, additions) {
	if (removals.indexOf('*') === -1) {
		// Use native jQuery methods if there is no wildcard matching
		$el.removeClass(removals)
		return !additions ? $el : $el.addClass(additions)
	}

	var patt = new RegExp('\\s' + removals.replace(/\*/g, '[A-Za-z0-9-_]+').split(' ').join('\\s|\\s') + '\\s', 'g')

	$el.each(function (i, it) {
		var cn = ' ' + it.className + ' '
		while (patt.test(cn)) {
			cn = cn.replace(patt, ' ')
		}
		it.className = jQuery.trim(cn)
	})

	return !additions ? $el : $el.addClass(additions)
}

var isInternUrl = function (url) {
	var siteUrl = layData.siteUrl
	if (siteUrl.startsWith('http://')) {
		siteUrl = siteUrl.substr(7)
	} else if (siteUrl.startsWith('https://')) {
		siteUrl = siteUrl.substr(8)
	}
	if (siteUrl.startsWith('www.')) {
		siteUrl = siteUrl.substr(4)
	}
	var checkUrl = url
	if (checkUrl.startsWith('http://')) {
		checkUrl = checkUrl.substr(7)
	} else if (checkUrl.startsWith('https://')) {
		checkUrl = checkUrl.substr(8)
	}
	if (checkUrl.startsWith('www.')) {
		checkUrl = checkUrl.substr(4)
	}
	if (checkUrl.startsWith(siteUrl)) {
		return true
	}
}

var isCDNURL = function (url) {
	var cdns = [
		'cloudfront.net',
		'cloudinary.com',
		'optimole.com',
		// Jetpack CDN
		'i0.wp.com',
		'i1.wp.com',
		'i2.wp.com',
		'i3.wp.com',
		'wp.com',
		'wordpress.com',
		'jetpack.com',
		// Cloudflare
		'imagedelivery.net',
		'cloudflare.com',
		'cloudflare.net',
		// Other popular CDNs
		'b-cdn.net',
		'bunnycdn.com',
		'stackpathcdn.com',
		'quic.cloud',
		'smushcdn.com',
		'smu.sh',
		'shortpixel.ai',
		'ewww.io',
		'imagekit.io',
	]
	for (var i = 0; i < cdns.length; i++) {
		if (url.indexOf(cdns[i]) !== -1) {
			return true
		}
	}
	return false
}

// make sure url is https or http in case user switched from http to https or the other way around
var filterURL = function (url) {
	if (url !== null && url != '' && typeof url != 'undefined') {
		if (isCDNURL(url)) {
			return url
		}
		url = getStaticUrl(url)
		// Check protocol (http:// or https://)
		if (url.substring(0, 7) == 'http://' && layData.is_ssl == true) {
			// Convert HTTP to HTTPS
			url = 'https://' + url.substring(7)
		} else if (url.substring(0, 8) == 'https://' && (layData.is_ssl == false || layData.is_ssl == '')) {
			// Convert HTTPS to HTTP
			url = 'http://' + url.substring(8)
		}

		// add www in case we're on a www domain, but the url does not contain www
		if (layData.has_www == 1) {
			if (layData.is_ssl == true) {
				// https://www.
				if (url.substring(0, 12) != 'https://www.') {
					// part is everything after https://
					var part = url.substring(8)
					url = 'https://www.' + part
				}
			} else {
				// http://www.
				if (url.substring(0, 11) != 'http://www.') {
					// part is everything after http://
					var part = url.substring(7)
					url = 'http://www.' + part
				}
			}
		} else {
			// no www, see if url needs removal of www
			if (layData.is_ssl == true) {
				if (url.substring(0, 12) == 'https://www.') {
					// part is everything after https://www.
					var part = url.substring(12)
					url = 'https://' + part
				}
			} else {
				// http://www.
				if (url.substring(0, 11) == 'http://www.') {
					// part is everything after http://www.
					var part = url.substring(11)
					url = 'http://' + part
				}
			}
		}
	}
	return url
}

var getStaticUrl = function (url) {
	if (url.startsWith('mailto:') || url.startsWith('#') || url.startsWith('tel:')) {
		return url
	}
	if (url.toLowerCase().startsWith('sms:')) {
		return url
	}
	if (url.substr(0, 1) == '/') {
		return layData.siteUrl + url
	}
	return url
}

var processInstagramEmbeds = function () {
	setTimeout(function () {
		if (typeof window.instgrm != 'undefined') {
			window.instgrm.Embeds.process()
		}
	}, 0)
}

var loadImagesInImagehoverRegion = function () {}

var setSrcAndSrcSetViaParent = function ($target) {
	$target.find('img.setsizes').each(function () {
		var srcset = jQuery(this).attr('data-srcset')
		var src = jQuery(this).attr('data-src')
		jQuery(this).attr({
			src: src,
			srcset: srcset,
		})
	})

	$target.find('img.lay-gif, img.lay-image-original').each(function () {
		var src = jQuery(this).attr('data-src')
		jQuery(this).attr('src', src)
	})
}

var setImageSizesAttribute = function ($target) {
	if (typeof $target == 'undefined') {
		$target = jQuery('body')
	}

	$target.find('img.setsizes:not(.setsizes-objectfit-cover), img.lazyload:not(.setsizes-objectfit-cover)').each(function () {
		var w = this.getBoundingClientRect().width

		var objectfit = jQuery(this).css('object-fit')

		if (w == 0) {
			var ar = parseFloat(jQuery(this).attr('data-ar'))
			var h = this.clientHeight
			w = h / ar
		}

		if (jQuery(this).attr('data-parent-fit') == 'cover' || objectfit == 'cover') {
			var w = parseInt(jQuery(this).attr('data-w'), 10)
			var h = parseInt(jQuery(this).attr('data-h'), 10)

			if (jQuery.isNumeric(w) && jQuery.isNumeric(h)) {
				var rect = this.parentNode.getBoundingClientRect()
				// parent anchor element can be width 0 and height 0 (for example for elementgrid), so we do:
				if (rect.width == 0 && rect.height == 0) {
					rect = this.parentNode.parentNode.getBoundingClientRect()
				}
				if (w / h < rect.width / rect.height) {
					w = rect.width
				} else {
					var imgH = rect.height
					w = (w / h) * imgH
				}
			}
		}

		if (w != 0) {
			w = roundUpSizes(w)
			// vanilla-lazyload js library needs data-sizes attribute, so i just set both sizes and data-sizes :)
			jQuery(this)
				.attr('sizes', w + 'px')
				.attr('data-sizes', w + 'px')
		}
	})
	setBackgroundSizesAttribute()
}

var roundUpSizes = function (w) {
	var sizes = [265, 512, 768, 1024, 1280, 1920, 2560, 3200, 3840, 4096]
	var width = w
	var i
	for (var i = 0; i < sizes.length; i++) {
		if (sizes[i] >= w) {
			width = sizes[i]
			break
		}
	}
	return width
}

var setBackgroundSizesAttribute = function ($target) {
	if (typeof $target == 'undefined') {
		$target = jQuery('body')
	}
	$target.find('.background-image img.setsizes.setsizes-objectfit-cover').each(function () {
		var rect = this.parentNode.getBoundingClientRect()
		if (this.parentNode.classList.contains('background-image-style-left_right') || this.parentNode.classList.contains('background-image-style-left') || this.parentNode.classList.contains('background-image-style-right')) {
			rect.width = rect.width / 2
		}
		// w = 265
		var w = parseInt(jQuery(this).attr('data-w'), 10)
		// h = 100
		var h = parseInt(jQuery(this).attr('data-h'), 10)
		var sizesW = 0

		// rect.height = 1008
		// rect.width = 465

		if (w / h > rect.width / rect.height) {
			// h100
			var imgH = rect.height
			sizesW = (w / h) * imgH
		} else {
			// w100
			sizesW = rect.width
		}
		sizesW = roundUpSizes(sizesW)
		jQuery(this)
			.attr('sizes', parseInt(sizesW, 10) + 'px')
			.attr('data-sizes', parseInt(sizesW, 10) + 'px')
	})
}

var setBodyClasses = function (obj) {
	var newClasses = 'type-' + obj.type + ' id-' + obj.id + ' slug-' + obj.slug + ' page-id-' + obj.id + ' postid-' + obj.id
	if (typeof obj.catid != 'undefined') {
		for (var i = 0; i < obj.catid.length; i++) {
			newClasses += ' category-' + obj.catid[i] + ' '
		}
	}

	// WordPress adds request-specific classes during the initial PHP render.
	// With AJAX navigation the body element persists, so those classes would
	// otherwise describe the page we came from (for example `single-artists`
	// on a normal page). Keep global/theme state classes intact and only remove
	// classes that WordPress derives from the current request.
	alterClass(
		jQuery('body'),
		'wp-singular page page-template page-template-* single single-* *-template-default archive post-type-archive post-type-archive-* category tag tag-* tax-* term-* author author-* date year month day search search-results search-no-results error404 attachment attachmentid-* attachment-* paged paged-*',
		''
	)
	alterClass(jQuery('body'), 'type-* id-* slug-* page-id-* postid-* category-*', newClasses)
	// Page settings: sync body classes on AJAX navigation; values may be boolean or string e.g. 'on'/'false'
	var truthy = function (v) {
		return v === true || v === 'on' || v === 'true' || v === 1
	}
	jQuery('body').toggleClass('lay-hide-sitetitle', truthy(obj.hide_site_title))
	jQuery('body').toggleClass('lay-hide-menu', truthy(obj.hide_menu))
	jQuery('body').toggleClass('lay-hide-menu-2', truthy(obj.hide_menu_2))
	jQuery('body').toggleClass('lay-hide-menu-3', truthy(obj.hide_menu_3))
	jQuery('body').toggleClass('lay-hide-menu-4', truthy(obj.hide_menu_4))
	jQuery('body').toggleClass('lay-hide-footer', truthy(obj.hide_footer))
	jQuery('body').toggleClass('lay-hide-fixed-header', truthy(obj.hide_fixed_header))
	// Re-apply deck-page chrome hide on AJAX navigation. The CSS rule
	// is `body.type-lay_deck.lay-deck-hide-chrome` — both classes must be
	// present, so we toggle this in lockstep with the type-* swap above.
	jQuery('body').toggleClass('lay-deck-hide-chrome', truthy(obj.deck_hide_chrome))
	// set body data attributes again. these were set before in history_controller_new.js. and they need to be set there so JS knows which page to fetch via ajax
	// but i re-set the attrs here because the info that was returned by PHP might be more accurate
	// for example when someone sets a text in a link. the data-cat attributes won't be updated, when the linked to project's categories change
	// to circumvent this, I set the category attributes by the info that was returned by php, rather than the data-attributes of the clicked-on-link that are saved in window.history.state

	jQuery('body').attr({
		'data-type': obj.type,
		'data-id': obj.id,
		'data-slug': obj.slug,
		'data-catid': stringifyCatIds(obj.catid),
		'data-footerid': obj.footerid,
	})

	var horizontalActiveAttr = obj && typeof obj.horizontal_scroll_active !== 'undefined' ? (obj.horizontal_scroll_active ? '1' : '0') : jQuery('body').attr('data-horizontal-scroll-active') || '0'
	jQuery('body').attr('data-horizontal-scroll-active', horizontalActiveAttr)
	if (document.body) {
		document.body.dataset.horizontalScrollActive = horizontalActiveAttr
	}
	var hasCustomPhoneLayoutAttr = obj && typeof obj.has_custom_phone_layout !== 'undefined' ? (obj.has_custom_phone_layout ? '1' : '0') : jQuery('body').attr('data-has-custom-phone-layout') || '0'
	jQuery('body').attr('data-has-custom-phone-layout', hasCustomPhoneLayoutAttr)
	if (document.body) {
		document.body.dataset.hasCustomPhoneLayout = hasCustomPhoneLayoutAttr
	}
	var html = document.documentElement
	if (html) {
		html.dataset.horizontalScrollActive = horizontalActiveAttr
		if (horizontalActiveAttr === '1') {
			html.classList.add('horizontal-scroll-active')
		} else {
			html.classList.remove('horizontal-scroll-active')
		}
	}

	// home!
	var url = window.location.href
	var lastChar = url.substring(url.length - 1)
	var lastChar2 = layData.siteUrl.substring(layData.siteUrl.length - 1)
	if (lastChar == '/' && lastChar2 != '/') {
		url = url.slice(0, -1)
	}
	if (url == layData.siteUrl) {
		jQuery('body').addClass('home')
	} else {
		jQuery('body').removeClass('home')
	}
}

var map = function (value, istart, istop, ostart, ostop) {
	return ostart + (ostop - ostart) * ((value - istart) / (istop - istart))
}

var initIsTouchDevice = function () {
	var userAgent = navigator.userAgent || navigator.vendor || window.opera
	var maxTouchPoints = navigator.maxTouchPoints || navigator.msMaxTouchPoints || 0
	var isTouchUA = /(iPhone|iPod|iPad|Android|playbook|silk|BlackBerry|BB10|Windows Phone|Tizen|Bada|webOS|IEMobile|Opera Mini)/.test(userAgent)
	// iPadOS in desktop mode reports as Macintosh, so use touch points
	var isIpadOS = /Macintosh/.test(userAgent) && maxTouchPoints > 1
	Utility.isTouchDevice = isTouchUA || isIpadOS
	// Keep body classes in sync with touch detection
	jQuery('body').toggleClass('touchdevice', Utility.isTouchDevice)
	jQuery('body').toggleClass('no-touchdevice', !Utility.isTouchDevice)

	// Detect iOS and add class to HTML element
	var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream

	if (isIOS) {
		jQuery('html').addClass('ios')

		// Detect iOS version from Version/XX.X in user agent
		// Example: "Version/26.0 Mobile/15E148 Safari/604.1"
		var iosVersion = userAgent.match(/Version\/(\d+)\.?(\d+)?/)
		if (iosVersion && iosVersion[1]) {
			var majorVersion = parseInt(iosVersion[1], 10)
			jQuery('html').addClass('ios-' + majorVersion)
		}
	}
}

var initResizeOnlyWindowWidthEvent = function () {
	// resize is triggered when height of window changes when scrolling on an iphone safari
	// for many things we only want to trigger functions when only window width changes, so i'll use window_width_changed instead of window.on('resize') many times
	var old_window_width = window.innerWidth
	jQuery(window).on('resize', function () {
		if (old_window_width != window.innerWidth) {
			jQuery(window).trigger('window_width_changed')
		}
		old_window_width = window.innerWidth
	})
}

var bindResize = function () {
	jQuery(window).on('orientationchange window_width_changed', function () {
		triggerSizeChanged()
		setOrientation()
	})
	// need to debounce this because every time an image's sizes attr is changed, the browser reloads it as seen in network tab
	jQuery(window).on(
		'window_width_changed',
		debounce(function () {
			setImageSizesAttribute()
		}, 300)
	)
}

var setOrientation = function () {
	Utility.orientation = window.innerWidth > window.innerHeight ? 'landscape' : 'portrait'
	if (Utility.orientation != Utility.previousOrientation) {
		window.laytheme.emit('orientationchanged', Utility.orientation)
	}
	Utility.previousOrientation = Utility.orientation
}

var initScreenSize = function () {
	if (window.innerWidth <= Utility.phoneBreakpoint) {
		Utility.screenSize = 'phone'
	} else if (window.innerWidth <= Utility.tabletBreakpoint) {
		Utility.screenSize = 'tablet'
	} else {
		Utility.screenSize = 'desktop'
	}
}

var triggerSizeChanged = function () {
	var previousSizeType = Utility.screenSize

	if (window.innerWidth <= Utility.phoneBreakpoint) {
		Utility.screenSize = 'phone'
	} else if (window.innerWidth <= Utility.tabletBreakpoint) {
		Utility.screenSize = 'tablet'
	} else {
		Utility.screenSize = 'desktop'
	}

	switch (Utility.screenSize) {
		case 'desktop':
			jQuery('html').addClass('desktop-size').removeClass('tablet-size phone-size')
			Utility.isPhoneSize = false
			Utility.isTabletSize = false
			Utility.isDesktopSize = true
			Utility.isDesktopOrTabletSize = true
			break
		case 'tablet':
			jQuery('html').addClass('tablet-size').removeClass('desktop-size phone-size')
			Utility.isPhoneSize = false
			Utility.isTabletSize = true
			Utility.isDesktopSize = false
			Utility.isDesktopOrTabletSize = true
			break
		case 'phone':
			jQuery('html').addClass('phone-size').removeClass('desktop-size tablet-size')
			Utility.isPhoneSize = true
			Utility.isTabletSize = false
			Utility.isDesktopSize = false
			Utility.isDesktopOrTabletSize = false
			break
	}

	// size-"type" has changed
	if (previousSizeType != Utility.screenSize) {
		globalevents_controller.triggerSizeChanged(Utility.screenSize)
	}
}

// somehow lazySizes.loader.unveil doesn't work on images that are not in-view
// but i cannot reproduce it here https://codepen.io/arminunruh/pen/oqvxjw

// so, when instant_load is enabled, some images still have the .lazyload class
// so i just load them here
// however: most images that are loaded in case of "instant_load" are actually loaded in
// "load_cpl_or_desktop_content_controller.js" and "load_visible_images_then_rest.js"
var loadImagesInstantly = function () {
	if (layData.image_loading == 'instant_load') {
		window.laytheme.on('newpageshown', function () {
			// only instantly load images and background images, not carousel images
			var imgs = jQuery('.img img.lazyload, .thumb img.lazyload, .background-image img.lazyload').get()
			imgs.forEach(function (img) {
				if (window.lazyLoadInstance && LazyLoad.load) {
					LazyLoad.load(img)
				}
			})

			setTimeout(function () {
				// only instantly load first image of carousel
				var imgs2 = jQuery('.lay-carousel-slide.is-selected img').get()
				imgs2.forEach(function (img) {
					if (window.lazyLoadInstance && LazyLoad.load) {
						LazyLoad.load(img)
					}
				})
			}, 200)
		})
	}
}

var bindSizeBackgrounds = function () {
	var hasObjectFit = document.documentElement && 'objectFit' in document.documentElement.style
	if (!hasObjectFit || layData.misc_options_alt_w100_h100_sizing == 'on') {
		window.laytheme.on('newpageshown', sizeBackgroundsIfObjectFitNotSupported)
		jQuery(window).on('resize orientationchange', sizeBackgroundsIfObjectFitNotSupported)
	}
}

var sizeBackgroundsIfObjectFitNotSupported = function () {
	setTimeout(function () {
		jQuery('.background-image img').each(function () {
			var ar = jQuery(this).attr('data-ar')
			var rowRect = this.parentNode.getBoundingClientRect()
			var rowAr = rowRect.height / rowRect.width

			if (typeof ar != 'undefined') {
				if (ar > rowAr) {
					this.classList.add('bgw100')
					this.classList.remove('bgh100')
				} else {
					this.classList.add('bgh100')
					this.classList.remove('bgw100')
				}
			} else {
				this.classList.add('bgw100')
				this.classList.remove('bgh100')
			}
		})
		// need to do this because otherwise sizes would just be 20px or sth way too small, bc image width has not been established before bgw100 or bgh100 was set
		setBackgroundSizesAttribute()

		jQuery('.background-video video').each(function () {
			var ar = jQuery(this).attr('data-ar')
			var rowRect = this.parentNode.getBoundingClientRect()
			var rowAr = rowRect.height / rowRect.width

			if (typeof ar != 'undefined') {
				if (ar > rowAr) {
					this.classList.add('w100')
					this.classList.remove('h100')
				} else {
					this.classList.add('h100')
					this.classList.remove('w100')
				}
			} else {
				this.classList.add('w100')
				this.classList.remove('h100')
			}
		})
	}, 0)
}

// var configureLazySizes = function () {
// 	// https://github.com/aFarkas/lazysizes/tree/master/plugins/optimumx#lying-sizes
// 	// https://github.com/aFarkas/lazysizes/issues/51#issuecomment-72522376
// 	// chrome upscales images sometimes, this prevents it
// 	var sizes = [265, 512, 768, 1024, 1280, 1920, 2560, 3200, 3840, 4096]

// 	document.addEventListener(
// 		'lazybeforesizes',
// 		(function (e) {
// 			return function (e) {
// 				var i
// 				for (i = 0; i < sizes.length; i++) {
// 					if (sizes[i] >= e.detail.width) {
// 						e.detail.width = sizes[i]
// 						break
// 					}
// 				}
// 			}
// 		})()
// 	)
// }

// playsinline is supported from iOS 10 WebKit and Chrome > 53
var setSupportsPlaysinlineOnTouchdevices = function () {
	Utility.supportsPlaysInline = true
	// Utility.supportsPlaysInline = false
	// if (Utility.isTouchDevice) {
	// 	var md = new MobileDetect(window.navigator.userAgent)
	// 	if (md.os() == 'iOS' && md.userAgent() == 'Safari') {
	// 		if (md.version('Safari') >= 10) {
	// 			Utility.supportsPlaysInline = true
	// 			return
	// 		}
	// 	}
	// 	if (md.os() == 'AndroidOS' && md.userAgent() == 'Chrome') {
	// 		if (md.version('Chrome') >= 53) {
	// 			Utility.supportsPlaysInline = true
	// 			return
	// 		}
	// 	}
	// 	// be optimistic for other combinations
	// 	Utility.supportsPlaysInline = true
	// }
}

// only do overflow-y: hidden :D
var fixBodyAlt = function () {
	if (!isFixed) {
		isFixed = true
		jQuery('html').css('overflow-y', 'hidden')
		if (jQuery.fn.fullpage && jQuery.fn.fullpage.setAllowScrolling != undefined) {
			try {
				jQuery.fn.fullpage.setAllowScrolling(false)
			} catch (e) {}
		}
	}
}

var isFixed = false
var fixedAtY = 0
var fixedBodyMode = null

var shouldUseOverflowBodyLock = function (reason) {
	return reason == 'page-overlay' && !Utility.isTouchDevice && document.querySelector('.lay-fixed-header-texts-mix-blend-difference') != null
}

// Internal function to actually apply/remove the fixed body styles
var applyFixedBodyStyles = function (reason) {
	if (!isFixed) {
		isFixed = true

		// Check if Lenis is active
		var bodyLenis = null
		if (window.smooth_scroll_controller && typeof window.smooth_scroll_controller.getInstance === 'function') {
			bodyLenis = window.smooth_scroll_controller.getInstance()
		}

		if (bodyLenis && typeof bodyLenis.stop === 'function') {
			fixedBodyMode = 'lenis'
			// When Lenis is active, use stop() to pause smooth scrolling
			// But we still need to prevent native browser scrolling
			bodyLenis.stop()
			// Add classes and overflow hidden to prevent native scrolling
			jQuery('html').addClass('body-scroll-disabled')
			jQuery('html').css('overflow-y', 'hidden')
			jQuery('body').css('overflow-y', 'hidden')
			// scrollbar-gutter: stable on html handles scrollbar compensation automatically
		} else if (shouldUseOverflowBodyLock(reason)) {
			fixedBodyMode = 'overflow'
			fixedAtY = window.scrollY || document.documentElement.scrollTop || window.pageYOffset || 0
			jQuery('html').addClass('body-scroll-disabled')
			jQuery('html').css('overflow-y', 'hidden')
			jQuery('body').css('overflow-y', 'hidden')
		} else {
			fixedBodyMode = 'fixed'
			// Fallback for non-Lenis scrolling: use position: fixed
			// Save current scroll position
			fixedAtY = window.scrollY || document.documentElement.scrollTop || window.pageYOffset || 0

			// Add class synchronously so CSS applies position: fixed immediately
			jQuery('body').addClass('body-position-fixed')

			// Set body position fixed
			document.body.style.top = -fixedAtY + 'px'
			// Use setTimeout to prevent glitch in Safari
			setTimeout(function () {
				jQuery('html').addClass('body-scroll-disabled')
			}, 0)
		}

		// Handle fullpage.js if present
		if (jQuery.fn.fullpage && jQuery.fn.fullpage.setAllowScrolling != undefined) {
			try {
				jQuery.fn.fullpage.setAllowScrolling(false)
			} catch (e) {}
		}
	}
}

var removeFixedBodyStyles = function () {
	if (isFixed) {
		isFixed = false
		var mode = fixedBodyMode
		fixedBodyMode = null

		// scrollbar-gutter: stable on html handles scrollbar compensation automatically

		// Check if Lenis is active
		var bodyLenis = null
		if (window.smooth_scroll_controller && typeof window.smooth_scroll_controller.getInstance === 'function') {
			bodyLenis = window.smooth_scroll_controller.getInstance()
		}

		// Always remove body-position-fixed class and top style, regardless of Lenis state
		jQuery('body').removeClass('body-position-fixed')
		document.body.style.top = ''

		if (mode == 'lenis' && bodyLenis && typeof bodyLenis.start === 'function') {
			// When Lenis is active, just use start() - it will resume scrolling at the same position
			// Lenis maintains the scroll position when stopped, so no need to restore it
			bodyLenis.start()
			// Remove classes and overflow styles
			jQuery('html').removeClass('body-scroll-disabled')
			jQuery('html').css('overflow-y', '')
			jQuery('body').css('overflow-y', '')
		} else if (mode == 'overflow') {
			jQuery('html').removeClass('body-scroll-disabled')
			jQuery('html').css('overflow-y', '')
			jQuery('body').css('overflow-y', '')
		} else {
			// Fallback for non-Lenis scrolling - restore scroll position and remove fixed styles
			// Set scroll position first
			window.scrollTo(0, fixedAtY)
			document.documentElement.scrollTop = fixedAtY

			// Then remove remaining fixed styles
			jQuery('html').removeClass('body-scroll-disabled')
			jQuery('html').css('overflow-y', '')

			// Final scroll position setting to ensure it's correct
			jQuery(document).scrollTop(fixedAtY)
		}

		// Handle fullpage.js if present
		if (jQuery.fn.fullpage && jQuery.fn.fullpage.setAllowScrolling != undefined) {
			try {
				jQuery.fn.fullpage.setAllowScrolling(true)
			} catch (e) {}
		}
	}
}

var fixBody = function (applyFixBodyStyle = false, reason) {
	// fixing body to prevent scrolling of background in safari when search is opened for example
	// Now integrated with Lenis smooth scroll support and scrollbar hiding
	if (applyFixBodyStyle) {
		applyFixedBodyStyles(reason)
	}
}

var unfixBody = function () {
	removeFixedBodyStyles()
}

var waitForMasonryInitialized = function (masonryCols) {
	var d = new jQuery.Deferred() //make a deferred

	var masonryInColsHasInitialized = []
	for (var i = 0; i < masonryCols.length; i++) {
		masonryInColsHasInitialized.push(false)
	}
	for (var i = 0; i < masonryCols.length; i++) {
		;(function (index) {
			var col = masonryCols[index]
			if (col.classList.contains('masonry-initialized')) {
				masonryInColsHasInitialized[index] = true
			} else {
				// wait until masonry has initialized
				var observer = new MutationObserver(() => {
					if (col.classList.contains('masonry-initialized')) {
						masonryInColsHasInitialized[index] = true
					}
				})
				observer.observe(col, { attributes: true, attributeFilter: ['class'] })
			}
		})(i)
	}
	var interval = setInterval(function () {
		// https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Array/every
		if (masonryInColsHasInitialized.every(arrayElIsTrue)) {
			d.resolve()
			clearInterval(interval)
		}
	}, 30)

	return d.promise() // return the promise the deferred object is wrapped around
}

var getMasonryColumns = function ($parents) {
	var $masonries = $parents.find('.contains-masonry-layout')
	if ($masonries.length == 0) {
		// in some cases the "parents" variable is the .contains-masonry-layout itself
		// because i do this: jQuery(['#grid .row[data-collapsed="false"] .col:not(.type-stack), #grid .col.place-freely', '.cover-region-desktop .row[data-collapsed="false"]…e-stack), .cover-region-desktop .col.place-freely', '#footer .row[data-collapsed="false"] .col:not(.type-stack), #footer .col.place-freely'])
		// and that just selects the columns themselves :)
		// so using "closest" i can test for this. ".find()" only tests for descendants
		$masonries = $parents.closest('.contains-masonry-layout')
	}

	if ($masonries.length == 0) {
		return []
	}
	var cols = []
	$masonries.each(function () {
		cols.push(this)
	})
	return cols
}

var getVisibleMasonryColumns = function ($parents) {
	var $masonries = $parents.find('.contains-masonry-layout')
	if ($masonries.length == 0) {
		// in some cases the "parents" variable is the .contains-masonry-layout itself
		// because i do this: jQuery(['#grid .row[data-collapsed="false"] .col:not(.type-stack), #grid .col.place-freely', '.cover-region-desktop .row[data-collapsed="false"]…e-stack), .cover-region-desktop .col.place-freely', '#footer .row[data-collapsed="false"] .col:not(.type-stack), #footer .col.place-freely'])
		// and that just selects the columns themselves :)
		// so using "closest" i can test for this. ".find()" only tests for descendants
		$masonries = $parents.closest('.contains-masonry-layout')
	}

	if ($masonries.length == 0) {
		return []
	}
	var cols = []
	$masonries.each(function () {
		if (isInsideViewport(this)) {
			cols.push(this)
		}
	})
	return cols
}

var arrayElIsTrue = function (element, index, array) {
	return element == true
}

var isInsideViewport = function (_this, yOffset = 0) {
	var rect = _this.getBoundingClientRect()
	if (rect.bottom > 0 && rect.top < window.innerHeight + yOffset && rect.right > 0 && rect.left < window.innerWidth) {
		return true
	}
	return false
}

// taken from layCarousel.js
var isElVisibleInsideCarousel = function (carousel_el, slide_el, offset) {
	// i use an offset so the next and previous images are loaded too
	var carousel_rect = carousel_el.getBoundingClientRect()
	var slide_rect = slide_el.getBoundingClientRect()
	var isInside = false

	var carouselLeft = carousel_rect.left - offset
	var carouselRight = carousel_rect.right + offset

	// the carousel rectangle spans from left to right
	// if a slide is left, right or center is within that span, the slide is visible in the carousel rectangle
	if (slide_rect.left >= carouselLeft && slide_rect.left <= carouselRight) {
		isInside = true
	}
	if (slide_rect.right >= carouselLeft && slide_rect.right <= carouselRight) {
		isInside = true
	}
	var slide_midpoint = slide_rect.left + slide_rect.width / 2
	if (slide_midpoint >= carouselLeft && slide_midpoint <= carouselRight) {
		isInside = true
	}

	return isInside
}

export { utility_controller, Utility, getMasonryColumns, waitForMasonryInitialized, getVisibleMasonryColumns, isInsideViewport, isElVisibleInsideCarousel, getTargetContainers, getTargetContainersExceptPageOverlay, roundUpSizes }

window.utility = Utility
window.utility_controller = utility_controller
